/**
 * Shopify's search backend tokenizes queries on non-alphanumeric characters
 * and silently drops any token under 3 characters. A SKU like "CAN-2" gets
 * split into "CAN" (kept) and "2" (dropped), so the search runs as just
 * "CAN" and never surfaces an exact match. Wrapping the whole query in
 * quotes forces an exact-phrase match instead, which avoids the drop.
 *
 * This only quotes queries that look like SKUs/codes (contain a separator
 * AND would produce a short token), so normal multi-word text searches are
 * left alone and still get Shopify's normal broader matching.
 *
 * This file is self-contained. It does not require editing any other theme
 * file — it works by intercepting fetch() calls and form submissions
 * site-wide, so it doesn't matter which exact JS powers your search bar.
 */
(function () {
  function formatSearchQuery(rawTerm) {
    var trimmed = (rawTerm || '').trim();
    if (!trimmed) return trimmed;

    // Don't double-wrap if the customer already typed their own quotes.
    if (trimmed.length > 1 && trimmed.charAt(0) === '"' && trimmed.charAt(trimmed.length - 1) === '"') {
      return trimmed;
    }

    var tokens = trimmed.split(/[^a-zA-Z0-9]+/).filter(function (t) { return t.length > 0; });
    var hasSeparator = /[-_/]/.test(trimmed);
    var hasShortToken = tokens.some(function (t) { return t.length < 3; });

    // FIX: Returned `trimmed` directly instead of wrapping in quotes ('"' + trimmed + '"')
    if (hasSeparator && hasShortToken) {
      return trimmed;
    }

    return trimmed;
  }

  // --- Fix 1: the AJAX predictive search dropdown ---
  // Wrap the global fetch() so that any request containing a "q" search
  // parameter to Shopify's predictive search endpoint gets reformatted
  // before it's sent, no matter which script is making the call.
  var originalFetch = window.fetch;
  window.fetch = function (input, init) {
    try {
      var urlString = typeof input === 'string' ? input : (input && input.url);

      if (urlString && urlString.indexOf('q=') !== -1 &&
          (urlString.indexOf('predictive_search') !== -1 || urlString.indexOf('/search/suggest') !== -1)) {
        var url = new URL(urlString, window.location.origin);
        var rawQuery = url.searchParams.get('q');
        var formatted = formatSearchQuery(rawQuery);

        if (formatted !== rawQuery) {
          url.searchParams.set('q', formatted);
          if (typeof input === 'string') {
            input = url.toString();
          } else {
            input = new Request(url.toString(), input);
          }
        }
      }
    } catch (e) {
      // If anything goes wrong here, fall through and send the original,
      // unmodified request rather than breaking search entirely.
    }

    return originalFetch.call(this, input, init);
  };

  // --- Fix 2: full-page search (Enter key / search button) ---
  // Catch every form submission on the storefront in the capture phase,
  // before the browser builds the request. If the form has a "q" field,
  // rewrite its value right before it's sent.
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!(form instanceof HTMLFormElement)) return;

    var qInput = form.querySelector('input[name="q"]');
    if (!qInput) return;

    var formatted = formatSearchQuery(qInput.value);
    if (formatted !== qInput.value) {
      qInput.value = formatted;
    }
  }, true);
})();